<!-- src/layout/AppMenuProfile.vue -->
<script setup>
import { useLayout } from '@/layout/composables/layout';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { useI18n } from 'vue-i18n';

const authStore = useAuthStore();
const router = useRouter();
const { t } = useI18n();
const { layoutState, layoutConfig, onMenuProfileToggle, isHorizontal, isSlim } = useLayout();

const menuClass = computed(() => (isHorizontal.value ? 'overlay' : null));

const username = computed(() => authStore.user?.username || '');
const roleStr = computed(() => authStore.user?.role_str || '');

// ✅ Avatar: Varsa göster, yoksa blank-avatar
const userAvatar = computed(() => {
    return authStore.user?.avatar || '/layout/images/avatar/blank-avatar.png';
});

const iconClass = computed(() => {
    const profilePositionStart = layoutConfig.menuProfilePosition === 'start';

    return {
        'pi-angle-up': (layoutState.menuProfileActive && (profilePositionStart || isHorizontal.value)) ||
            (!layoutState.menuProfileActive && !profilePositionStart && !isHorizontal.value),
        'pi-angle-down': (!layoutState.menuProfileActive && profilePositionStart) ||
            (layoutState.menuProfileActive && !profilePositionStart) ||
            isHorizontal.value
    };
});

function toggleMenu() {
    const menu = document.querySelector('.menu-transition');

    if (layoutState.menuProfileActive) {
        menu.style.maxHeight = '0';
        menu.style.opacity = '0';
        if (isHorizontal.value) {
            menu.style.transform = 'scaleY(0.8)';
        }
    } else {
        menu.style.maxHeight = menu.scrollHeight + 'px';
        menu.style.opacity = '1';
        if (isHorizontal.value) {
            menu.style.transform = 'scaleY(1)';
        }
    }

    onMenuProfileToggle();
}

const tooltipValue = (tooltipText) => isSlim.value ? tooltipText : null;

const logauth = () => {
    authStore.logout();
    router.push('/auth/login');
};
</script>

<template>
    <div class="layout-menu-profile">
        <button v-tooltip="{ value: tooltipValue('Profile') }" @click="toggleMenu">
            <img :src="userAvatar" alt="avatar"
                style="width: 32px; height: 32px; border-radius: 50%; object-fit: cover;" />
            <span>
                <strong>{{ username }}</strong>
                <small>{{ roleStr }}</small>
            </span>
            <i class="layout-menu-profile-toggler pi pi-fw" :class="iconClass"></i>
        </button>

        <ul :class="['menu-transition', menuClass]" style="overflow: hidden; max-height: 0; opacity: 0">
            <li v-tooltip="{ value: tooltipValue('Profile') }">
                <button class="p-link" @click="router.push('/user/profile')">
                    <i class="pi pi-file-o pi-fw"></i>
                    <span>Profil</span>
                </button>
            </li>

            <li v-tooltip="{ value: tooltipValue('Logout') }">
                <button class="p-link" @click="logauth()">
                    <i class="pi pi-power-off pi-fw"></i>
                    <span>{{ t('auth.log_out') }}</span>
                </button>
            </li>
        </ul>
    </div>
</template>